import React from "react";
import { shape, string, number } from "prop-types";

const propTypes = {
  grantBox: shape({
    numberOfGrants: number,
  }),
  query: string,
  grantSearchUrl: string,
};

const GrantsCallout = (props) => {
  const { query, grantBox, grantSearchUrl } = props;

  if (!query || !grantBox) return null;
  return (
    <div className="search-component__grants-callout-wrapper">
      <div className="search-component__grants-callout">
        <div className="search-component__grants-callout-copy">
          See "{query}" in Committed Grants
        </div>
        <a href={grantBox.linkToGrantSearch}>
          {grantBox.numberOfGrants} Grants found
        </a>
      </div>
    </div>
  );
};

GrantsCallout.propTypes = propTypes;
export default GrantsCallout;
